import { createSelector } from "reselect"
import { chain, get, keyBy } from "lodash"
import { getPortfoliosLookup } from "selectors/portfolios"
import { getWatchlistsLookup } from "selectors/watchlists"
import { getPortfolioUrlGetter, getSwapUrlGetter, getWatchlistUrlGetter, getResearchTopicExperimentUrlGetter, getPortfolioExperimentUrlGetter, getResearchTopicUrlGetter } from "selectors/urls"
import { computeErrorNotification, computeSuccessNotification, computeInProgressNotification, computeWaitingNotification, NOTIFICATION_STATUSES } from "../helpers"

const getStartingNotifications = state => state.global.data.notifications.data
const getUpdatedNotifications = state => state.modules.serverNotifications.updatedNotifications
const getExperiments = state => get(state, "global.data.experiments.data")

const getStartingNotificationsMap = createSelector(
  [getStartingNotifications],
  (startingNotifications) => keyBy(startingNotifications, "id"),
)

export const getNotifications = createSelector(
  [getStartingNotificationsMap, getUpdatedNotifications, getPortfoliosLookup, getPortfolioUrlGetter, getSwapUrlGetter, getWatchlistsLookup, getWatchlistUrlGetter, getPortfolioExperimentUrlGetter, getResearchTopicUrlGetter, getResearchTopicExperimentUrlGetter, getExperiments],
  (startingNotificationsMap, updatedNotifications, portfoliosLookup, portfolioUrlGetter, swapUrlGetter, watchlistsLookup, watchlistUrlGetter, portfolioExperimentUrlGetter, researchTopicUrlGetter, researchTopicExperimentUrlGetter, experiments) => {
    const notifications = { ...startingNotificationsMap, ...updatedNotifications }
    return chain(notifications)
      .map(notif => {
        const { error, success, total } = notif
        if (error === total) {
          return computeErrorNotification(notif, swapUrlGetter, portfoliosLookup, portfolioUrlGetter, watchlistsLookup, watchlistUrlGetter, researchTopicUrlGetter, experiments)
        } else if (error + success === total) {
          return computeSuccessNotification(notif, swapUrlGetter, portfoliosLookup, portfolioUrlGetter, watchlistsLookup, watchlistUrlGetter, portfolioExperimentUrlGetter, researchTopicExperimentUrlGetter, experiments)
        } else if (error + success > 0) {
          return computeInProgressNotification(notif, portfoliosLookup, watchlistsLookup, experiments, error, success)
        } else {
          return computeWaitingNotification(notif, portfoliosLookup, watchlistsLookup, experiments)
        }
      })
      .orderBy(["createdAt"], ["desc"])
      .value()
  },
)

export const getAverageCompletion = createSelector(
  [getNotifications],
  (notifications) => {
    const avg = chain(notifications)
      .pickBy(n => n.status === NOTIFICATION_STATUSES.IN_PROGRESS)
      .map(n => n.progress)
      .mean()
      .value()

    return (!Number.isFinite(avg) || avg === 0)
      ? false
      : avg
  },
)
